import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { filter, reduce } from 'lodash'
import { makeStyles } from '@material-ui/core/styles'
import { MenuItem, TextField, Chip } from '@material-ui/core'

const useSelectStyles = makeStyles((theme) => ({
  noLabel: {
    marginTop: theme.spacing(3),
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
}))

const getOptionsObj = (options) =>
  reduce(
    options,
    (obj, option) => {
      obj[option.value] = option.label
      return obj
    },
    {},
  )

const MultiSelectChips = ({ id, options = [], value = [], className, onChange, ...rest }) => {
  const classes = useSelectStyles()
  const OPTIONS_OBJ = useMemo(() => getOptionsObj(options), [options])
  return (
    <TextField
      select
      fullWidth
      variant="outlined"
      SelectProps={{
        multiple: true,
        renderValue: (selected) => (
          <div className={classes.chips}>
            {selected.map((currentValue) => (
              <Chip
                key={currentValue}
                label={OPTIONS_OBJ[currentValue] || currentValue}
                className={classes.chip}
                color="primary"
                variant="outlined"
                onDelete={() => {
                  onChange(filter(value, (chip) => chip !== currentValue))
                }}
                onMouseDown={(e) => e.stopPropagation()}
              />
            ))}
          </div>
        ),
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...rest}
    >
      {options.map((option) => {
        const isSelected = value.indexOf(option.value) !== -1
        return (
          <MenuItem
            key={option.value}
            value={option.value}
            style={{ fontWeight: isSelected ? 'bold' : 'normal' }}
          >
            {option.label}
          </MenuItem>
        )
      })}
    </TextField>
  )
}

MultiSelectChips.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
}

export default MultiSelectChips
